import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CityGateway } from "../gateway/CityGateway";
import { City } from "src/app/domain/models/City";
import { Routes } from "src/app/infrastructure/routes";

@Injectable({providedIn: 'root'})
export class CityService extends CityGateway {

  constructor(private _http: HttpClient){
    super()
  }

  getAll(): Observable<City[]> {
    return this._http.get<City[]>(Routes.cityApi + '/GetAll')
  }

  getByCountry(countryId: number): Observable<City[]> {
    return this._http.get<City[]>(Routes.cityApi + '/GetByCountry', {params: {countryId}})
  }

}
